import { Link } from "react-router-dom";
import { DISCLAIMER_TEXT } from "@/lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-slate-200 dark:border-slate-800 bg-slate-50/60 dark:bg-slate-950/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
        <p data-testid="footer-disclaimer" className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed max-w-3xl">
          {DISCLAIMER_TEXT}
        </p>
        <div className="mt-6 flex items-center justify-between text-xs text-slate-400 dark:text-slate-500 flex-wrap gap-3">
          <a
            href="https://smartnote2self.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-brand-link"
            className="hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
          >
            © {new Date().getFullYear()} SmartNote2Self · Kaiventive Holdings Ltd
          </a>
          <div className="flex items-center gap-5">
            <Link to="/testimonials" data-testid="footer-testimonials-link" className="hover:text-slate-700 dark:hover:text-slate-200 transition-colors">Testimonials</Link>
            <Link to="/faq" data-testid="footer-faq-link" className="hover:text-slate-700 dark:hover:text-slate-200 transition-colors">FAQ</Link>
            <Link to="/privacy" className="hover:text-slate-700 dark:hover:text-slate-200 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-slate-700 dark:hover:text-slate-200 transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
